import React, { useEffect } from "react";
import OrderTable from "./components/OrderTable";
import { useDispatch } from "react-redux";
import { resetPlacedOrderData } from "store/orderSlice";

function OrderPage({ status }) {
  // ✅ Component name starts with uppercase
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetPlacedOrderData());
  }, [dispatch, status]);

  return (
    <div>
      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-1">
        <OrderTable key={status?._id} status={status} />
      </div>
    </div>
  );
}

export default OrderPage;
